module.exports = __webpack_public_path__ + "static/measuresentences-ec17b6bb5bb5c338e96ef4c0a71b1ec1.png";